import { createMemoStyles } from '@wds/utils';
import { HeaderTheme } from '../../theme';

type MobileNavStyleProps = {
  title: string;
  theme: HeaderTheme;
};

const useMobileNavStyles = createMemoStyles(
  ({ breakpoints, palette, spacing, radius, height }: HeaderTheme) => ({
    mobileNavContainer: (props: MobileNavStyleProps) => ({
      display: 'flex',
      justifyContent: props?.title ? 'left' : 'center',
      alignItems: 'center',
      width: '100%',
      height: spacing[7],
      color: palette.text.dark,

      [`@media (min-width: ${breakpoints.md}px)`]: {
        justifyContent: 'left',
        marginLeft: spacing[8],
      },

      '& > div > div > .wds-overlay': {
        top: height,
      },
    }),
    mobileNavBoxFull: {
      width: '100%',
    },
    mobileNavLogo: (props: MobileNavStyleProps) => ({
      width: props?.title ? 'initial' : '100%',
      textAlign: props?.title ? 'left' : 'center',
    }),
    createButton: {
      display: 'inline-block',
      backgroundColor: palette.primary.main,
      color: palette.text.light,
      padding: spacing[4],
      position: 'fixed',
      right: spacing[4],
      bottom: spacing[4],
      borderRadius: radius.large,
    },
    mobileNavMenu: {
      '& > ul > li, & > ul > ul > li ': {
        '& > [role="button"], & > a': {
          borderLeft: `8px solid transparent`,
          borderBottom: `solid 1px ${palette.border.main}`,

          '&:hover, &:active, &:focus': {
            background: palette.background.light,
            borderLeft: `8px solid ${palette.primary.main}`,
          },
        },
        '& > [role="region"] > ul li > a': {
          borderLeft: `8px solid transparent`,
          background: palette.background.accent,

          '&:hover, &:focus': {
            borderLeft: `8px solid ${palette.primary.main}`,
          },
        },
      },
    },
  })
);

export default useMobileNavStyles;
